export const scrollWithOffset = (el, additionalOffset = 0) => {
    const offset = 100; // Adjust this value to match the height of your fixed header
    const elementPosition = el.offsetTop;
    const offsetPosition = elementPosition - offset - additionalOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };
  